import {h, Component} from 'preact';
import firebase from 'utils/firebase';
import {parseCurrency, formatDate, formatTime} from 'helpers';


const months = {
	'1': 'TAMMI',
	'2': 'HELMI',
	'3': 'MAALIS',
	'4': 'HUHTI',
	'5': 'TOUKO',
	'6': 'KESÄ',
	'7': 'HEINÄ',
	'8': 'ELO',
	'9': 'SYYS',
	'10': 'LOKA',
	'11': 'MARRAS',
	'12': 'JOULU'
}

class SingleTicket extends Component {
	getEvent = (id) => {
		// const db = firebase.firestore();
		// db.collection("events")
		// .doc(id)
		// .get()
		// .then((doc) => {
		// 	if (doc.exists) {
		//         console.log("Document data:", doc.data());
		// 		this.setState({event: doc.data()})
		//     } else {
		//         // doc.data() will be undefined in this case
		//         console.log("No such document!");
		//     }
		// });
		fetch('https://us-central1-lippumaatti.cloudfunctions.net/api/events/'+id)
		.then(res => res.json())
		.then(event => {
			this.setState({...event, loading:false});
		})
	}

	componentDidMount(){
		this.getEvent(this.props.ticket.event_id)
	}
	render({ticket, background}, {event}, {user, cart}) {
		return event ?
		<div class="container card"	style={background ? `background:white;position:absolute;box-shadow: rgba(0, 0, 0, 0.15) 0px 0px ${1/background}rem 0px;overflow:hidden; border-radius:0.75rem;transform:translate3d(-4px, -4px, 0) rotateZ(-${background }deg);transform-origin:0 0;width:calc(100% - 4rem);` : "background:white;position:relative;box-shadow: rgba(0, 0, 0, 0.15) 0px 0px 1rem 0px;overflow:hidden; border-radius:0.75rem;"}>
			<div class="row">
				<div class="col-12 col-xl-8 p-0">
						<div class="embed-responsive embed-responsive-16by9">
							<section class="p-0 mb-0 embed-responsive-item">
								<div class="carousel-cell bg-dark text-light overlay d-flex flex-column justify-content-end h-100" >
										<img src={event.image} alt="Image" class="bg-image opacity-80" />
										<div class="container">
										<div class="row px-2 py-3 p-lg-6">
											<div class="col">
												<div>
													<h1 class="mt-3 mb-0 h3">{event.title}</h1>
													<div class="d-flex mt-2">
														<div class="d-flex align-items-center">
															<div class="mr-4 d-flex flex-column justify-content-center align-items-center">
																<span class="block text-small text-muted">{months[formatDate(event.start_date).split('.')[1]]}</span>
																<h4 class="lead mb-0">{formatDate(event.start_date).split('.')[0]}</h4>
															</div>
														</div>
														<div class="mr-4">
															<span class="text-white">{event.address}</span><br/>
															<span class="text-muted">{event.city}</span>
														</div>
														<div class="mr-4">
															<span class="text-white">{this.props.cart.items.length} kpl</span><br/>
															<span class="text-muted">{ parseCurrency(cart.getTotal(this.props.cart ? this.props.cart.items : [])) }</span>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</section>

						</div>
					</div>
				<div class="col-12 col-lg-4">
					<div class="d-flex justify-content-center align-items-center">
						<div class="p-2 py-4 p-xl-4">
							<div class="mb-4">
								<h4 class="mb-1">{event.title}</h4>
								<h5 class="text-primary"><strong>{formatDate(event.start_date)} klo {formatTime(event.start_date)}</strong></h5>
							</div>
							<div class="mb-4">
								<h5 class="mb-1 text-small">{event.location}</h5>
								<p>{event.address}, {event.city}</p>
							</div>
							<div class="d-flex justify-content-between">
								<div class="mb-2">
									<h6 class="mb-1">Nimi</h6>
									{user ? <p>{user.displayName}</p> : null}
								</div>
								<div class="mb-2">
									<h6 class="mb-1">{this.props.cart.items.length} kpl</h6>
									<p>{parseCurrency(cart.getTotal(this.props.cart ? this.props.cart.items : []))}</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

 		:
		<div class="row">
			<div class="col-12 col-md-8 p-0">
					<div class="embed-responsive embed-responsive-16by9">
						<section class="p-0 mb-0 embed-responsive-item">
							<div class="carousel-cell bg-dark text-light overlay d-flex flex-column justify-content-end h-100" >
									<div class="container">
									<div class="row px-2 py-3 p-lg-6">
										<div class="col">
											<div>
												<h1 class="text-primary" waiting></h1><br/>
												<span class="text-muted" waiting></span>
											</div>
										</div>
									</div>
								</div>
							</div>
						</section>
					</div>
				</div>
			<div class="col-12 col-md-4 bg-primary-3 text-white">
				<div>
					<div class="p-2 p-md-4">
						<span  waiting />
						<h6 class="text-muted w-100" waiting></h6>
					</div>
					<div class="px-2 px-md-4">
						<span  waiting />
						<h6 class="text-muted w-100" waiting></h6>
					</div>
				</div>
			</div>
		</div>

	}
}

/*

<div class="container card"	style="overflow:hidden">
	<div class="row">
		<div class="col-12 col-md-8 p-0">
				<div class="embed-responsive embed-responsive-16by9 d-none d-md-block d-print-none">
					<section class="p-0 mb-0 embed-responsive-item">
						{event.image ?
						<div class="carousel-cell bg-dark text-light overlay d-flex flex-column justify-content-end h-100" >
								<img src={event.image} alt="Image" class="bg-image opacity-80" />
								<div class="container">
								<div class="row px-2 py-3 p-lg-6">
									<div class="col">
										<div>
											<h1 class="mt-0 h3 h1-lg">{event.title}</h1>
											<div class="d-flex mt-2">
												<div class="d-flex align-items-center">
													<div class="mr-4 d-flex flex-column justify-content-center align-items-center">
														<span class="block text-small text-muted">{months[formatDate(event.start_date).split('.')[1]]}</span>
														<h4 class="lead mb-0">{formatDate(event.start_date).split('.')[0]}</h4>
													</div>
												</div>
												<div>
													<span class="text-white">{event.location}</span><br/>
													<span class="text-muted">{event.city}</span>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div> :
						<div class="carousel-cell bg-grey text-light overlay d-flex flex-column justify-content-end"	style="min-height: 15.5rem" />}
					</section>

				</div>
				<div class="embed-responsive embed-responsive-16by9 d-none d-print-block">
					<section class="p-0 mb-0 embed-responsive-item">
						{event.image ?
						<div class="carousel-cell d-flex flex-column justify-content-between h-100" >
							<div class="container">
									<div class="row p-4 py-lg-4 px-lg-6">
										<div class="col-md-8">
											<img src="/assets/lippumaatti-logo.png" style="height: 3rem;" />
										</div>
									</div>
								</div>
								<div class="container">
								<div class="row px-4 p-lg-6">
									<div class="col">
										<div>
											<h1 class="mt-0 h3 h1-lg">{event.title}</h1>
											<div class="d-flex mt-2">
												<div class="d-flex align-items-center">
													<div class="mr-4 d-flex flex-column justify-content-center align-items-center">
														<span class="block text-small text-muted">{months[formatDate(event.start_date).split('.')[1]]}</span>
														<h4 class="lead mb-0">{formatDate(event.start_date).split('.')[0]}</h4>
													</div>
												</div>
												<div>
													<span>{event.location}</span><br/>
													<span class="text-muted">{event.city}</span>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div> :
						<div class="carousel-cell bg-grey text-light overlay d-flex flex-column justify-content-end"	style="min-height: 15.5rem" />}
					</section>
				</div>
			</div>
		<div class="col-12 col-md-4">
			<div class="d-flex justify-content-center align-items-center">
				{user ? <div class="p-2 p-md-4">
					<div class="mb-4">
						<h4 class="mb-1">{ticket.title || 'Lipun otsikko'}</h4>
						<h5 class="text-primary"><strong>{ticket.description || 'Kuvaus'}</strong></h5>
					</div>
					<div class="d-flex justify-content-between">
						<QRCode value={props.ticket} />
					</div>
				</div> : null}
			</div>
		</div>
	</div>
</div>


*/


export class Tickets extends Component {
	render(props,state) {
		return <div class="p-4 mt-4" style="position:relative;">
			{[...this.props.cart.items].reverse().slice(0,4).map((ticket,index,arr) => <SingleTicket ticket={ticket} cart={props.cart} background={arr.length - index - 1} /> )}
 		</div>
	}
}
export default Tickets;



// WEBPACK FOOTER //
// ./components/tickets/index.js